<div class="subscribe-block" *ngIf="!subscribed">
  <h3>Узнавайте первыми о наших новостях и новинках</h3>
  <div class="subscribe-input">
    <input class="base-input subscribe" [(ngModel)]="email" [placeholder]="'email'"[formControl]="emailControl">

    <button mat-button class=" main-button" (click)="subscribe()">Подписаться</button>

  </div>
  <mat-error
    *ngIf="emailControl.errors">{{getErrorText(emailControl.errors)}}</mat-error>

</div>
